var Updown, moment, request;

moment = require('moment');

request = require('request');


/*
Updown
Simple API wrapper for the updown.io service
 */

Updown = (function() {

  /*
  	Constructor method
  	@param {string} apiKey - Your Updown API key
  	@param {object} config - A configuration object. Currently only supports the `readOnly` property
   */
  function Updown(apiKey, config) {
    this.apiKey = apiKey;
    if (config == null) {
      config = {};
    }
    this.readOnly = config.readOnly || false;
  }


  /*
  	Loads an URL with the Updown API key header
  	@param {string} url - The API URL to call
  	@param {object} query - (optional) Parameters to be added to the querystring
  	@param {function} callback - Is called when the request completes
   */

  Updown.prototype._get = function(url, query, callback) {
    var ref;
    if (query == null) {
      query = {};
    }
    if (typeof query === 'function' && (callback == null)) {
      ref = [query, {}], callback = ref[0], query = ref[1];
    }
    query._t = new Date().getTime();
    return request({
      url: url,
      method: 'GET',
      json: true,
      qs: query,
      headers: {
        'X-API-KEY': this.apiKey
      }
    }, function(err, response, data) {
      return callback(err, data);
    });
  };


  /*
  	Posts data to an URL with the Updown API key header
  	@param {string} method - Method for the HTTP request
  	@param {string} url - The API URL to post to
  	@param {object} params - Parameters to be sent in the POST body
  	@param {function} callback - Is called when the request completes
   */

  Updown.prototype._req = function(method, url, params, callback) {
    return request({
      url: url,
      method: method,
      json: true,
      form: params,
      headers: {
        'X-API-KEY': this.apiKey
      }
    }, function(err, response, data) {
      return callback(err, data);
    });
  };


  /*
  	Gets all checks for the user
   */

  Updown.prototype.getChecks = function() {
    return new Promise((function(_this) {
      return function(resolve, reject) {
        return _this._get('https://updown.io/api/checks', function(err, data) {
          if (err) {
            return reject(err);
          }
          return resolve(data);
        });
      };
    })(this));
  };


  /*
  	Gets downtime information about a specific check
  	@param {string} token - The token for a check
  	@param {number} page - The page number (results are paginated per 100)
   */

  Updown.prototype.getDowntime = function(token, page) {
    return new Promise((function(_this) {
      return function(resolve, reject) {
        var query;
        if (typeof token !== 'string') {
          return reject(new TypeError('token parameter should be a string'));
        }
        if (typeof page !== 'number') {
          return reject(new TyepError('page parameter should be a number'));
        }
        query = {};
        if (page != null) {
          query.page = page;
        }
        return _this._get('https://updown.io/api/checks/' + token + '/downtimes', query, function(err, data) {
          if (err) {
            return reject(err);
          }
          return resolve(data);
        });
      };
    })(this));
  };


  /*
  	Gets metrics for a specific check
  	@param {string} token - The token for a check
  	@param {number} from - Start date of the metrics (timestamp in milliseconds)
  	@param {number} to - End date of the metrics (timestamp in milliseconds)
  	@param {boolean} sortByTime - Set this to true if you want to get results separated by time instead of totals
   */

  Updown.prototype.getMetrics = function(token, from, to, sortByTime) {
    if (sortByTime == null) {
      sortByTime = false;
    }
    return new Promise((function(_this) {
      return function(resolve, reject) {
        var query;
        if (typeof token !== 'string') {
          return reject(new TypeError('token parameter should be a string'));
        }
        query = {};
        if (from != null) {
          query.from = moment(from).format('YYYY-MM-DD hh:mm:ss');
        }
        if (to != null) {
          query.to = moment(to).format('YYYY-MM-DD hh:mm:ss');
        }
        if (sortByTime) {
          query.group = 'time';
        }
        return _this._get('https://updown.io/api/checks/' + token + '/metrics', query, function(err, data) {
          if (err) {
            return reject(err);
          }
          return resolve(data);
        });
      };
    })(this));
  };


  /*
  	Adds new check
  	@param {string} url - The URL to check
  	@param {number} interval - The interval in seconds (30, 60, 120, 300 or 600)
  	@param {string} name - (optional) An alias to recognise this url by
   */

  Updown.prototype.addCheck = function(url, interval, name) {
    return new Promise((function(_this) {
      return function(resolve, reject) {
        var params;
        if (_this.readOnly) {
          return reject(new Error('Updown is set to read-only mode'));
        }
        if (typeof url !== 'string') {
          return reject(new TypeError('url parameter should be a string'));
        }
        if (typeof interval !== 'number') {
          return reject(new TypeError('interval parameter should be a number'));
        }
        if (interval !== 30 && interval !== 60 && interval !== 120 && interval !== 300 && interval !== 600) {
          return reject(new RangeError('interval must be 30, 60, 120, 300 or 600'));
        }
        params = {
          url: url,
          period: interval
        };
        if (name != null) {
          params.name = name;
        }
        return _this._req('POST', 'https://updown.io/api/checks/', params, function(err, data) {
          if (err) {
            return reject(err);
          }
          return resolve(data);
        });
      };
    })(this));
  };


  /*
  	Modifies a check
  	@param {string} token - The token 
  	@param {string} url - (optional) The new URL
  	@param {number} interval - (optional) The new interval in seconds (30, 60, 120, 300 or 600)
  	@param {string} name - (optional) A new alias for the check
   */

  Updown.prototype.modifyCheck = function(token, url, interval, name) {
    return new Promise((function(_this) {
      return function(resolve, reject) {
        var params;
        if (_this.readOnly) {
          return reject(new Error('Updown is set to read-only mode'));
        }
        if (typeof token !== 'string') {
          return reject(new TypeError('token parameter should be a string'));
        }
        if ((url != null) && typeof url !== 'string') {
          return reject(new TypeError('url parameter should be a string'));
        }
        if ((interval != null) && typeof interval !== 'number') {
          return reject(new TypeError('interval parameter should be a number'));
        }
        if ((interval != null) && (interval !== 30 && interval !== 60 && interval !== 120 && interval !== 300 && interval !== 600)) {
          return reject(new RangeError('interval must be 30, 60, 120, 300 or 600'));
        }
        params = {};
        if (url != null) {
          params.url = url;
        }
        if (interval != null) {
          params.period = interval;
        }
        if (name != null) {
          params.name = name;
        }
        return _this._req('PUT', 'https://updown.io/api/checks/' + token, params, function(err, data) {
          if (err) {
            return reject(err);
          }
          return resolve(data);
        });
      };
    })(this));
  };


  /*
  	Deletes a check
  	@param {string} token - Token of the check to delete
   */

  Updown.prototype.deleteCheck = function(token) {
    return new Promise((function(_this) {
      return function(resolve, reject) {
        if (_this.readOnly) {
          return reject(new Error('Updown is set to read-only mode'));
        }
        if (typeof token !== 'string') {
          return reject(new TypeError('token parameter should be a string'));
        }
        return _this._req('DELETE', 'https://updown.io/api/checks/' + token, {}, function(err, data) {
          if (err) {
            return reject(err);
          }
          return resolve(data);
        });
      };
    })(this));
  };

  return Updown;

})();

module.exports = Updown;



//////////////////
// WEBPACK FOOTER
// ./node_modules/node-updown/lib/updown.class.js
// module id = /Bwv
// module chunks = 0